import {
  List,
  ListItem,
  ListItemText,
  Box,
  Typography,
  ListItemIcon
} from '@mui/material'
import { useFormStore } from '../../functions/formStore'
import { Check } from "@mui/icons-material"


const Confirm = (): JSX.Element => {
  const { data } = useFormStore()
  return (
    <Box>
      <Box display="grid" justifyContent={"center"} marginY={5}>
        <Typography variant="h6" borderBottom={2} borderColor={"GrayText"} color="gray">ご入力内容のご確認</Typography>
      </Box>
      <List>
        <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} >
         <ListItem>
            <ListItemIcon><Check /></ListItemIcon>
            <ListItemText primary="お客さまについて" secondary={data.No1} />
          </ListItem>
         <ListItem>
            <ListItemIcon><Check /></ListItemIcon>
            <ListItemText primary="法人・個人" secondary={data.No2} />
          </ListItem>
          <ListItem>
            <ListItemIcon><Check /></ListItemIcon>
            <ListItemText primary="会社名・組織名" secondary={data.No3} />
          </ListItem>
          <ListItem>
            <ListItemIcon><Check /></ListItemIcon>
            <ListItemText primary="部署名・店舗名" secondary={data.No4} />
          </ListItem>
          <ListItem>
            <ListItemIcon><Check /></ListItemIcon>
            <ListItemText primary="役職" secondary={data.No5} />
          </ListItem>
          <ListItem>
            <ListItemIcon><Check /></ListItemIcon>
            <ListItemText primary="ご利用の家賃債務保証会社・管理会社名" secondary={data.No6} />
          </ListItem>
          <ListItem>
            <ListItemIcon><Check /></ListItemIcon>
            <ListItemText primary="お名前" secondary={data.No7} />
          </ListItem>
          <ListItem>
            <ListItemIcon><Check /></ListItemIcon>
            <ListItemText primary="フリガナ" secondary={data.No8} />
          </ListItem>
          <ListItem>
            <ListItemIcon><Check /></ListItemIcon>
            <ListItemText primary="電話番号" secondary={data.No9} />
          </ListItem>
          <ListItem>
            <ListItemIcon><Check /></ListItemIcon>
            <ListItemText primary="メールアドレス" secondary={data.No10} />
          </ListItem>
          <ListItem>
            <ListItemIcon><Check /></ListItemIcon>
            <ListItemText primary="住所" secondary={data.No11} />
          </ListItem>
         <ListItem>
            <ListItemIcon><Check /></ListItemIcon>
            <ListItemText primary="テラシテRを知ったきっかけを教えてください" secondary={data.No12} />
          </ListItem>
         <ListItem>
            <ListItemIcon><Check /></ListItemIcon>
            <ListItemText primary="お問合せ内容" secondary={data.No13} />
          </ListItem>
          <ListItem>
            <ListItemIcon><Check /></ListItemIcon>
            <ListItemText primary="お問合せ内容詳細" secondary={data.No14} />
          </ListItem>
         <ListItem>
            <ListItemIcon><Check /></ListItemIcon>
            <ListItemText primary="個人情報保護基本方針について(リンクはこちら)" secondary={data.No15} />
          </ListItem>
        </Box>
      </List>
    </Box>
  )
}

export default Confirm